import { SVGProps } from './SVGProps';

const ChevronRightV2 = ({ fill = '#154734', width = '25', height = '25', ...rest }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.79504 7.77694L13.375 12.3669L8.79504 16.9569L10.205 18.3669L16.205 12.3669L10.205 6.36694L8.79504 7.77694Z"
        fill={fill}
      />
    </svg>
  );
};

export default ChevronRightV2;
